import { useEffect } from 'react';
export const usePostMessageHandler = (uuid, handlers) => {
  useEffect(() => {
    const postMessageHandler = event => {
      try {
        const {
          data: rawData,
          source
        } = event;
        const parsedData = JSON.parse(rawData);
        if (parsedData.uuid !== uuid || !uuid || !parsedData.uuid) {
          return;
        }
        const {
          type,
          data
        } = parsedData;
        const handler = handlers[type];
        if (typeof handler === 'function') {
          handler({
            data,
            source
          });
        }
      } catch (e) {
        // Event data is not JSON,
        // or it doesn't have the expected structure,
        // we can safely ignore it, since it's origin
        // is most likely not the widget.
        return;
      }
    };
    window.addEventListener('message', postMessageHandler);
    return () => window.removeEventListener('message', postMessageHandler);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
};